var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { NgxSpinnerService } from 'ngx-spinner';
import { OnInit } from '@angular/core';
import { Validators, FormControl } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { UserService } from 'src/app/services/user.service';
import { BorradorStorageService } from '../../../services/borrador-storage.service';
var crearBorradorComponent = /** @class */ (function () {
    function crearBorradorComponent(_userService, snackbar, dialog, spinner, borradorStorageService) {
        this._userService = _userService;
        this.snackbar = snackbar;
        this.dialog = dialog;
        this.spinner = spinner;
        this.borradorStorageService = borradorStorageService;
        // @Output() borradorGuardado = new EventEmitter<boolean>();
        this.borradorFormControl = new FormControl('', [
            Validators.required
        ]);
        this.matcher = new FormService();
    }
    crearBorradorComponent.prototype.ngOnInit = function () {
        this.borradores = this.allStorage();
    };
    crearBorradorComponent.prototype.saveDraft = function () {
        var _this = this;
        //console.log("/////////saveDraft////////////////")
        this.spinner.show();
        this._userService.saveDraft(this.borradorFormControl.value, this.borradores).subscribe(function (response) {
            // console.log('saveDraft response',response)
            // console.log('saveDraft response.id._id',response.id._id)
            if (response.borrador) {
                sessionStorage.setItem("borrador", response.id._id);
                _this.borradorStorageService.cambioStorage();
                // this.borradorGuardado.emit(true);
                _this.dialog.closeAll();
                _this.spinner.hide();
                _this.snackbar.open('Borrador guardado con exito', 'Aceptar', {
                    duration: 1500
                });
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    crearBorradorComponent.prototype.allStorage = function () {
        console.log(localStorage);
        return Object.keys(localStorage)
            .reduce(function (obj, k) {
            var _a, _b;
            if (k == 'form' || k == 'formId' || k == 'formTitle') { // para que 3.10 llegue completo                    
                return __assign({}, obj, (_a = {}, _a[k] = typeof localStorage[k] !== 'undefined' ? localStorage.getItem(k) : '', _a));
            }
            else {
                return __assign({}, obj, (_b = {}, _b[k] = typeof localStorage[k] !== 'undefined' ? JSON.parse(localStorage.getItem(k)) : '', _b));
            }
            /*   return { ...obj, [k]: JSON.parse(localStorage.getItem(k)) } */
        }, {});
    };
    return crearBorradorComponent;
}());
export { crearBorradorComponent };
